module.exports = __webpack_public_path__ + "b1fa99dbf336475ba29b1c6dcf6087f6.pdf";